import * as React from 'react';

import { goToTracking, ifLoggedIn, trackingUrl } from 'src/utils/navigation';
import './MyOrdersTracking.scss';
import trackerIcon from 'src/assets/trackingIcon';
import i18n from 'src/translation/i18n';

interface IMyOrdersTrackingState {
  floatingIsOpen: boolean;
}

interface IMyOrdersTrackingProps {
  isLoggedIn: boolean;
}

export default class MyOrdersTracking extends React.Component<
  any,
  IMyOrdersTrackingState
> {
  private flyMenuRef: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      floatingIsOpen: false
    };
  }

  /* 
    openMenu
   */
  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      floatingIsOpen: false
    });
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  private goToTracking = () => ifLoggedIn(() => goToTracking());

  public render() {
    const { t } = this.props;
    const menuState = this.state.floatingIsOpen ? 'opened' : '';

    return (
      <div
        className="my-orders-menu--my-account"
        onClick={this.handleMenuState}
      >
        <div className="my-orders-menu--info">
          <a
            href={trackingUrl()}
            className="menu-item menu-link"
            onClick={this.goToTracking}
          >
            <div>
              {/* <i className="rpds rpds-place rp-locations-button--icon" /> */}
              <img
                src={trackerIcon}
                alt="Your Tracking"
                className="tracker-icon"
              />
              <div>{i18n.t('common.trackOrder')}</div>
            </div>
          </a>
        </div>
      </div>
    );
  }
}
